module.exports = __webpack_public_path__ + "static/media/yuddhame.2ebdb76d.jpg";